export interface GoogleConfig {
  maps: {
    apiKey: string;
  };
  reCaptcha: {
    url: string;
    secret: string;
  };
}
